import React, { useEffect, useContext } from "react";
import tw from "twin.macro";

import { default as Newsletter } from "./event";
import UpdatesContext from "./context";

const NewsletterList = tw.div`flex flex-col gap-2 mt-4 items-start`;
const MemoLink = tw.a`text-sm tracking-wide text-blue-900 hocus:text-blue-700`;

const Newsletters = () => {
  const updatesContext = useContext(UpdatesContext);
  const { loading, error, getMemos, memos } = updatesContext;

  useEffect(() => {
    getMemos();
    //eslint-disable-next-line
  }, []);

  return (
    <NewsletterList>
      {loading
        ? "Loading..."
        : error
        ? error
        : memos.map((e, i) => (
        <MemoLink key={`memo-${i}`} href={e.file}>{e.date}</MemoLink>
          ))}
    </NewsletterList>
  );
};

export default Newsletters;
